import MUITypography from "@mui/material/Typography";

const Typography = MUITypography;

export default Typography;
